module.exports = ".checkoutanand{\n    padding-bottom: 3px;\n    padding-top: 10px;\n    border: solid 1px #ccc;\n    color: #314bae;\n    border-radius: 40px;\n    padding-left: 40px;\n    padding-right: 40px;\n    margin-bottom: 20px;\n    font-size: 30px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/payment.component.css
// module id = ./src/app/payment/payment.component.css
// module chunks = main